import { Stack, Typography } from "@mui/material";

export default function TermsAndConContent({ ...props }) {
    return (
        <Stack spacing={5} {...props}>
            <Typography variant="body2" >
                <strong>1. Data Protection</strong> 
                <br/> 
                Your privacy is important to us. All personal information and data you provide through our application will be handled in accordance with applicable data protection laws. We take reasonable measures to safeguard your data from unauthorized access, misuse, or disclosure. By using this application, you agree to our Privacy Policy and consent to the collection, processing, and storage of your data as outlined therein. 
            </Typography>
            <Typography variant="body2" >
                <strong>2. User Discretion </strong> 
                <br/> 
                You are responsible for the accuracy and relevance of the data you provide or upload. While our platform offers secure options for data submission, it is your discretion to decide what data to share. You acknowledge that any information or data you choose to upload is done voluntarily, and you assume responsibility for its content.
            </Typography>
            <Typography variant="body2" >
                <strong>3. Data Sharing</strong> 
                <br/> 
                We will never share or sell your data to third parties without your explicit consent unless required by law. Certain data may be anonymized and used for research, analysis, or application improvement purposes. 
            </Typography>
            <Typography variant="body2" >
                <strong>4. Liability </strong> 
                <br/> 
                You agree that by using this application, you are responsible for any decisions made based on the data you upload or input. We are not liable for any misuse of your data by third parties, nor do we guarantee the accuracy of data you upload.
            </Typography>
            <Typography variant="body2" >
                If you have any inquiries, concerns or reports, please contact us at <a href={`mailto:${process.env.REACT_APP_HELP_EMAIL}`} style={{ color: 'inherit', textDecoration: 'underline' }}>{process.env.REACT_APP_HELP_EMAIL}</a>
            </Typography>
        </Stack>
    )
}